// DialogEstimateEdit Component

/* eslint indent: 0, react/jsx-indent: 0 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Dialog from '../../../common/layout/dialog/dialog.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import FormAutoComplete from '../../../common/form/auto_complete/auto_complete.jsx'
import Select from '../../../common/form/select/select.jsx'
import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import AddressSelect from '../../../common/form/address_select/address_select.jsx'

class DialogEstimateEdit extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      contactId: '',
      projectId: '',
      displayContactName: '',
      showError: false,
      contactLabel: '',
      dataDate: null,
      contactPersonOptions: [],
      contactPersonId: '',
      addressOptions: [],
      addresses: [],
      address: null,
      pdfLanguage: ''
    }

    this.data = {
      suppliers: [],
      pdfLanguages: [
        { label: 'user.profile.optionNederlands', value: 'nl' },
        { label: 'user.profile.optionEnglish', value: 'en' },
        { label: 'user.profile.optionDeutsch', value: 'de' }
      ],
      projects: [],
      bHideDrop: false
    }

    this._bContactSearchPending = false
    this._contactSearchKeyword = ''
    this._references = {
      inputSupplier: React.createRef(),
      selectProject: React.createRef(),
      confirmDelete: React.createRef()
    }
  }

  static get propTypes () {
    return {
      onSubmit: PropTypes.func,
      supplierSearch: PropTypes.func,
      getProjects: PropTypes.func,
      onDelete: PropTypes.func,
      projectId: PropTypes.string,
      showLanguage: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      onSubmit: null,
      supplierSearch: null,
      getProjects: null,
      onDelete: null,
      projectId: '',
      showLanguage: false
    }
  }

  show (estimate) {
    FabButtonManager.setVisible(false)
    if (estimate) {
      this._handleSupplierSelect('contactId', estimate.options)
      const defaultPersonId =
        estimate.contactPersonOptions.length > 0
          ? estimate.contactPersonOptions[0].value
          : ''

      this.setState({
        contactPersonOptions: estimate.contactPersonOptions,
        contactPersonId: estimate.contactPerson
          ? estimate.contactPerson
          : defaultPersonId,
        addressOptions: estimate.addressOptions ? estimate.addressOptions : [],
        addresses: estimate.addresses ? estimate.addresses : [],
        address: estimate.contactAddress,
        pdfLanguage: estimate.pdfLanguage
      })
    }

    this.setState({
      contactLabel: this.state.displayContactName,
      projectId: this.props.projectId,
      active: true
    })
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({
      active: false,
      contactId: '',
      projectId: '',
      displayContactName: '',
      contactLabel: '',
      showError: false,
      dataDate: null,
      contactPersonOptions: [],
      contactPersonId: '',
      addressOptions: [],
      addresses: [],
      address: null,
      pdfLanguage: ''
    })

    this.data.bHideDrop = false
    if (this._references.inputSupplier.current) {
      this._references.inputSupplier.current.clearError()
    }

    if (this._references.selectProject.current) {
      this._references.selectProject.current.clearError()
    }
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._onKeyDown)
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._onKeyDown)
  }

  _onKeyDown = ev => {
    if (this.state.active && ev.keyCode === 13) {
      this._onFormSubmit(ev)
    }
  }

  render () {
    const classHeader = !this.state.showError
      ? 'dialogform-header'
      : 'dialogform-header showerr'
    const { showLanguage } = this.props

    return (
      <Dialog active={this.state.active} onClose={this.hide.bind(this)}>
        <div className='dialog-form estimateedit-form'>
          <div className={classHeader}>
            {!this.state.showError ? (
              <div className='title'>
                <IntlMessage ident='estimate.form.estimateEditTitle' />
                &nbsp;
                <span>
                  {this.state.contactLabel ? this.state.contactLabel : ''}
                </span>
              </div>
            ) : (
              <div className='info'>
                <IntlMessage ident='estimate.form.estimateEditErrorInfo' />
              </div>
            )}
            <IconButton
              icon='wizard-close'
              className='modal wizard-close dialog-form-close'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />
          </div>
          <div className='dialogform-content'>
            <form
              className='form'
              method='post'
              noValidate
              action='#'
              onSubmit={this._onFormSubmit.bind(this)}
            >
              <div className='form-layout'>
                <div className='layoutcol'>
                  <div className='formsection'>
                    <div className='formrow'>
                      <div className='formcol'>
                        <FormAutoComplete
                          label='estimate.form.labelSupplier'
                          ref={this._references.inputSupplier}
                          validations={['required']}
                          name='contactId'
                          value={this.state.contactId}
                          displayValue={this.state.displayContactName}
                          options={this.data.suppliers}
                          onChange={this._handleSearchSupplier.bind(this)}
                          onSelect={this._handleSupplierSelect.bind(
                            this,
                            'contactId'
                          )}
                          hideAdd
                          hasAutoSelect
                        />
                      </div>
                    </div>
                    {this.data.bHideDrop ? (
                      <div className='formrow'>
                        <div className='formcol'>
                          <span className='norecrds'>
                            <IntlMessage ident='estimate.form.noProjectsFoundForClient' />
                          </span>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className='formrow'>
                          <div className='formcol'>
                            <Select
                              options={this.data.projects}
                              name='projectId'
                              label='estimate.form.labelProject'
                              ref={this._references.selectProject}
                              value={this.state.projectId}
                              className='form-dropdown'
                              onChange={this._onChangeInput.bind(
                                this,
                                'projectId'
                              )}
                            />
                          </div>
                        </div>
                        {showLanguage && this._renderLanguageOptions()}
                      </>
                    )}
                    {this.state.contactPersonOptions &&
                      this.state.contactPersonOptions.length > 0 && (
                        <div className='formrow'>
                          <div className='formcol'>
                            <Select
                              options={this.state.contactPersonOptions}
                              name='contactPersonId'
                              className='form-dropdown'
                              label='invoice.form.labelContactPerson'
                              value={this.state.contactPersonId}
                              onChange={this._onChangeInput.bind(
                                this,
                                'contactPersonId'
                              )}
                            />
                          </div>
                        </div>
                      )}
                    <div className='formrow'>
                      <div className='formcol2'>
                        <AddressSelect
                          addressOptions={this.state.addressOptions}
                          address={this.state.address}
                          onSelectAddress={this._onSelectAddress.bind(this)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <IconButton
              type='primary'
              size='big'
              icon='action-delete'
              title='estimate.form.editEstimateDelete'
              className='actdelete'
              canHover={false}
              onClick={this._clickDelete.bind(this)}
            />
            <IconButton
              type='primary'
              size='big'
              icon='common-success-tick'
              title='estimate.form.editEstimateSave'
              canHover={false}
              onClick={this._onFormSubmit.bind(this)}
            />
            <ConfirmDelete
              ref={this._references.confirmDelete}
              title='estimate.form.msgOnDelete'
              onClickOk={this._onClickDeleteConfirm.bind(this)}
            />
          </div>
        </div>
      </Dialog>
    )
  }

  _renderLanguageOptions () {
    const { pdfLanguages } = this.data
    return (
      <div className='formrow'>
        <div className='formcol'>
          <Select
            options={pdfLanguages}
            name='pdfLanguage'
            value={this.state.pdfLanguage}
            multilingualOptions
            label='estimate.form.labelPdfLanguage'
            className='form-dropdown'
            onChange={this._onChangePdfLanguage.bind(this, 'pdfLanguage')}
          />
        </div>
      </div>
    )
  }

  /* Event Handlers */
  _onSelectAddress (addressType) {
    let address = null

    if (this.state.addresses && this.state.addresses.length > 0) {
      address = _.find(
        this.state.addresses,
        address => address.type.toLowerCase() === addressType
      )
    }

    this.setState({ address: address, dataDate: new Date() })
  }

  _onFormSubmit (ev) {
    ev.preventDefault()
    let noErrors = 0

    if (
      this._references.inputSupplier.current &&
      !this._references.inputSupplier.current.validate()
    ) {
      noErrors++
    }

    if (
      this._references.selectProject.current &&
      !this._references.selectProject.current.validate()
    ) {
      noErrors++
    }

    if (noErrors === 0) {
      let contactPerson = null
      if (
        this.state.contactPersonId &&
        this.state.contactPersonOptions &&
        this.state.contactPersonOptions.length > 0
      ) {
        contactPerson = _.find(this.state.contactPersonOptions, contact => {
          return contact.value === this.state.contactPersonId
        })
      }

      const estimateObj = {
        contactId: this.state.contactId,
        projectId: this.state.projectId,
        pdfLanguage: this.state.pdfLanguage,
        contactPerson: contactPerson ? contactPerson.obj : null,
        contactAddress: this.state.address ? this.state.address : null
      }

      if (this.props.onSubmit) {
        this.props.onSubmit(estimateObj)
      }
    } else {
      this.setState({ showError: true })
    }
  }

  _onClickClose (ev) {
    ev.preventDefault()
    this.hide()
  }

  _clickDelete (ev) {
    ev.preventDefault()
    if (this._references.confirmDelete.current) {
      this._references.confirmDelete.current.show()
    }
  }

  _onClickDeleteConfirm (e) {
    e.preventDefault()

    if (this.props.onDelete) {
      this.props.onDelete(this.state.invoiceId)
    }
  }

  _onChangeInput (name, value) {
    if (
      name === 'projectId' &&
      value &&
      this._references.selectProject.current
    ) {
      this._references.selectProject.current.clearError()
    }

    this.setState({ [name]: value })
  }

  _handleSearchSupplier (keyword) {
    if (keyword && this._references.inputSupplier.current) {
      this._references.inputSupplier.current.clearError()
    }

    this.setState({ displayContactName: keyword })
    this._processSupplierSearch(keyword)
  }

  _processSupplierSearch (keyword) {
    if (keyword.length < 1) return

    if (!this._bContactSearchPending) {
      this._bContactSearchPending = true
      if (this.props.supplierSearch) {
        this.props.supplierSearch(
          keyword,
          this._onSearchRecieved.bind(this, keyword)
        )
      }
    } else {
      this._contactSearchKeyword = keyword
    }
  }

  _onSearchRecieved (keyword, result) {
    this._bContactSearchPending = false

    this.data.suppliers = result
    const stateObj = {}
    if (result && result.length > 0) {
      stateObj.contactId = ''
      stateObj.contactName = keyword
    }

    this.setState(stateObj)

    if (this._contactSearchKeyword) {
      const keyword = this._contactSearchKeyword
      this._contactSearchKeyword = ''
      this._processSupplierSearch(keyword)
    }
  }

  _onChangePdfLanguage (name, value) {
    this.setState({ pdfLanguage: value, dataDate: new Date() })
  }

  _handleSupplierSelect (name, obj) {
    if (obj) {
      this.setState({ [name]: obj.value, displayContactName: obj.label })

      if (this.props.getProjects) {
        this.props.getProjects(obj.value, obj => {
          this.data.projects = obj

          this.data.bHideDrop = false
          if (this.data.projects.length === 0) {
            this.data.bHideDrop = true
          }

          this.setState({ dataDate: new Date() })
        })
      }
    } else {
      this.data.projects = []
      this.data.bHideDrop = false

      this.setState({ [name]: '' })
    }
  }
}

export default DialogEstimateEdit
